<template>
  <section class="list-item p-t-b-100">
    <div class="container">
      <h2 class="title text-center wow slideInUp">成为合作伙伴</h2>
      <div class="des text-center  wow slideInUp">
        打造属于自己的专属聚合支付SaaS平台
      </div>
      <div class="content-box wow slideInUp">
        <div class="step"><span>1</span>
          <p>签订合同</p>
        </div>
        <div class="step-line">
          <div class="step"><span>2</span>
            <p>开发对接</p>
          </div>
        </div>

        <div class="step"><span>3</span>
          <p>上线运营</p>
        </div>
      </div>
      <!-- <a class="but wow slideInUp" data-wow-delay="0.1s" href="https://www.wenjuan.com/s/3QBRBv" target="_blank">
        申请合作
      </a> -->
      <div class="but wow slideInUp" data-wow-delay="0.1s" @click="onShopApply">
        申请合作
      </div>
    </div>
    <ApplyCooperation v-model="show"/>
  </section>
</template>

<script>
  import ApplyCooperation from '../../common/PCApplyCooperation'
  export default {
    data() {
      return {
        show: false
      };
    },
    created() {

    },
    methods: {
      onShopApply() {
        let width = document.documentElement.clientWidth;
        //PC弹框   移动跳转页面
        if (width > 768) {
          this.show = !this.show;
        } else {
          this.$router.push({
            name: 'mobileApplyCooperation'
          })
        }
      },
    },
    components: {
      ApplyCooperation
    }
  };
</script>

<style scoped lang="scss">
  .list-item {
    background-image: url("~@/assets/product/openInterface/mg_cpzx_cbzf_kfjk_05@2x.jpg");
    background-size: cover;
    background-position: center;
    height: 6.4rem;
    color: #fff;

    .but {
      width: 3.4rem;
      padding: 0.14rem;
      margin: 0.7rem auto 0 auto;
      display: block;
      cursor: pointer;
      font-weight: bold;
      text-align: center;
      background: $color-primary;
    }

    .des {
      color: #fff;
    }

    .content-box {
      max-width: 6rem;
      margin: 0.4rem auto;
      display: flex;
      justify-content: space-between;

      .step-line {
        flex: 1;
        position: relative;

        &::before,
        &::after {
          content: ' ';
          height: 2px;
          background-image: linear-gradient(to right, #ccc 0%, #ccc 50%, transparent 50%);
          background-size: 8px 2px;
          background-repeat: repeat-x;
          position: absolute;
          top: 50%;
          width: calc(50% - 0.8rem);
        }

        &::before {
          left: 0.1rem;
        }

        &::after {
          right: 0.1rem;
        }

        .step {
          margin: 0 auto;
        }
      }

      .step {
        width: 1.2rem;
        height: 1.2rem;
        background-color: #fff;
        border-radius: 100%;
        color: $color-primary;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        font-size: 0.14rem;
        font-weight: bold;

        span {
          font-size: 0.42rem
        }

        p {
          margin-top: 0.02rem;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .list-item {
      background-image: url("~@/assets/product/openInterface/mg_cpzx_cbzf_kfjk_05@2x.jpg");
      height: 4rem;

      .content-box {
        .step-line {

          &::before,
          &::after {
            width: calc(50% - 0.6rem);
            background-size: 5px 1px;
          }
        }

        .step {
          width: 0.7rem;
          height: 0.7rem;
          font-size: 0.12rem;

          span {
            font-size: 0.22rem
          }
        }
      }

      .but {
        width: 2rem;
        font-size: 0.16rem;
        margin-top: 0.3rem;
      }
    }
  }
</style>